import { render, staticRenderFns } from "./AppVideo2.vue?vue&type=template&id=54f6f4db&scoped=true&"
import script from "./AppVideo2.vue?vue&type=script&lang=js&"
export * from "./AppVideo2.vue?vue&type=script&lang=js&"
import style0 from "./AppVideo2.vue?vue&type=style&index=0&id=54f6f4db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f6f4db",
  null
  
)

export default component.exports